import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Header from "./components/Header/index.js";
import Body from "./components/Body/Body";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useHyperlink } from "./context/HyperlinkProvider";
import usePavanData from "./hooks/usePavanData";

// Import the january2024.json file
// import january2024 from "./components/Body/january2024.json";
const Footer = lazy(() => import("./components/FooterNew/index.js"));
const NewYear = lazy(() => import("./components/NewYear/newyear.js"));
const Proprty = lazy(() => import("./components/Property/proprty.js"));
const Highlights = lazy(() => import("./components/Highlights/Highlights"));
const Morganlogos = lazy(() => import("./components/Morganlogos/Morganlogos.js"));
const Whysunwest = lazy(() => import("./components/Whysunwest/Morganscan.js"));
const EventComponent = lazy(() => import("./components/Event/Event.js"));
const Testimonial = lazy(() => import("./components/Testimonials/Testimonials.js"));
// const ShiningStar = lazy(() => import("./components/ShiningStar/shiningstar.js"));

function App() {
  const [webinarData, setWebinarData] = useState();
  const [bannerData, setBannerData] = useState();
  const [highlightsData, setHighlightsData] = useState();
  const [propertyData, setPropertyData] = useState();
  const [EventsData, setEventsData] = useState();
  const [formData, setFormData] = useState();
  const [aiBrandingData, setAiBrandingData] = useState();
  const [NewyearData, setNewyearData] = useState();
  const [links, setLinks] = useState(null); // Set initial state as null

  const appVersion = appversion.version;

  const [angelAiLink, setAngelAiLink] = useState('');
  const [angelComLink, setAngelComLink] = useState('');
  const [sunwestMortgageLink, setSunWestMortgageLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();
  const pavanData = usePavanData();


  useEffect(() => {
    const processContent = async () => {

      const sunwestMortgageLink = await getHyperLink('websites', 'swmc',1);
      const swLink = await getHyperLink('websites', 'swmc', 0);
      const aiLink = await getHyperLink('websites', 'angelai', 0);
      const aiComLink = await getHyperLink('websites','angelai',1);
      const cellLink = await getHyperLink('websites', 'celligence', 1);
      const celliLlcLink = await getHyperLink('websites', 'celligence', 0);
      const pavan = await getHyperLink('profiles', 'pavan', 0);

      setSunWestMortgageLink(sunwestMortgageLink || 'Sun West Mortgage Company, Inc.');
      setAngelAiLink(aiLink || 'AngelAi');
      setAngelComLink(aiComLink || 'AngelAi.com');
      setSunWestLink(swLink || 'Sun West Mortgage Company, Inc.');
      setCelligenceLink(cellLink || 'Celligence');
      setCelligenceLlcLink(celliLlcLink || 'Celligence LLC');
      setPavanLink(pavan || 'Pavan Agarwal');



    };
    processContent();
  }, [getHyperLink])

  useEffect(() => {
    //Comment out the axios request if we're using the local JSON
    const fetchMorganWebinarJSON = async () => {
      await axios.get(process.env.REACT_APP_CDN_LINK + "mastermind/january2024/january2024.json")
        .then(response => {
          const webinarJsonData = response.data;
          setWebinarData(webinarJsonData);
          setBannerData(webinarJsonData.banner);
          setHighlightsData(webinarJsonData.highlights);
          setPropertyData(webinarJsonData.property);
          setNewyearData(webinarJsonData.Newyear);
          setEventsData(webinarJsonData.Events);
          setFormData(webinarJsonData.signupform);
        }, error => {
          console.log(error);
        });

    };
    fetchMorganWebinarJSON();

    // Set the data from the local JSON file
    // setWebinarData(january2024);
    // setBannerData(january2024.banner);
    // setHighlightsData(january2024.highlights);
    // setPropertyData(january2024.property);
    // setNewyearData(january2024.Newyear);
    // setEventsData(january2024.Events);
    // setFormData(january2024.signupform);
  }, []);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_CDN_LINK + "jsons/ai-branding.json");
        setLinks(response.data);
        // console.log(JSON.stringify(response.data));
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);


  return (
    <div className="bodyContainer">
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true}
        isVerboseMode={false}
        metaFileDirectory={"."}
      >
        <>
          <Header 
            fetchpriority="high" 
            aiBrandingData={aiBrandingData} 
            angelAiLink={angelAiLink}
            angelComLink={angelComLink}
            sunwestMortgageLink={sunwestMortgageLink}
          />
  
          {bannerData ? (
            <>
              <Body 
                bannerData={bannerData} 
                formData={formData} 
                links={links} 
                fetchpriority="high"
                angelAiLink={angelAiLink}
                angelComLink={angelComLink}
                sunwestMortgageLink={sunwestMortgageLink}
              />
  
              <Suspense fallback={<div />}>
                <NewYear 
                  NewyearData={NewyearData} 
                  links={links} 
                  fetchpriority="low"
                  angelAiLink={angelAiLink}
                  angelComLink={angelComLink}
                  sunwestMortgageLink={sunwestMortgageLink}
                />
              </Suspense>
  
              <Suspense fallback={<div />}>
                {highlightsData && (
                  <Highlights 
                    highlightsData={highlightsData} 
                    links={links}
                    angelAiLink={angelAiLink}
                    angelComLink={angelComLink}
                    sunwestMortgageLink={sunwestMortgageLink}
                  />
                )}
              </Suspense>
  
              <Suspense fallback={<div />}>
                {propertyData && (
                  <Proprty 
                    propertyData={propertyData} 
                    links={links}
                    angelAiLink={angelAiLink}
                    angelComLink={angelComLink}
                    sunwestMortgageLink={sunwestMortgageLink}
                  />
                )}
              </Suspense>
  
              <Suspense fallback={<div />}>
                {links ? (
                  <EventComponent 
                    EventsData={EventsData} 
                    links={links} 
                    fetchpriority="low"
                    angelAiLink={angelAiLink}
                    angelComLink={angelComLink}
                    sunwestMortgageLink={sunwestMortgageLink}
                  />
                ) : (
                  <Spinner animation="border" role="status" />
                )}
              </Suspense>
  
              <Suspense fallback={<div />}>
                <Testimonial 
                  links={links} 
                  fetchpriority="low"
                  angelAiLink={angelAiLink}
                  angelComLink={angelComLink}
                  sunwestMortgageLink={sunwestMortgageLink}
                />
              </Suspense>
  
              <Suspense fallback={<div />}>
                {links ? (
                  <Morganlogos 
                    links={links} 
                    fetchpriority="low"
                    angelAiLink={angelAiLink}
                    angelComLink={angelComLink}
                    sunwestMortgageLink={sunwestMortgageLink}
                  />
                ) : (
                  <Spinner animation="border" role="status" />
                )}
              </Suspense>
  
              <Suspense fallback={<div />}>
                {links ? (
                  <Whysunwest 
                    links={links} 
                    fetchpriority="low"
                    angelAiLink={angelAiLink}
                    angelComLink={angelComLink}
                    sunwestMortgageLink={sunwestMortgageLink}
                    pavanLink={pavanLink}
                    sunwestLink={sunwestLink}
                    pavanData={pavanData}
                  />
                ) : (
                  <Spinner animation="border" role="status" />
                )}
              </Suspense>
  
              <Suspense fallback={<div />}>
                <Footer 
                  angelAiLink={angelAiLink}
                  angelComLink={angelComLink}
                  sunwestMortgageLink={sunwestMortgageLink}
                />
              </Suspense>
            </>
          ) : (
            ""
          )}
        </>
      </CacheBuster>
    </div>
  );
  
}

export default App;
